// Lista de componentes
export const APPLICANT = {
    HOME: () => 'HOME_APPLICANT',
    
};
  